import { IconButton, useColorModeValue } from "@chakra-ui/react";
import SunsetIcon from "./SunsetIcon";

export default function SunsetAngleButton({
  showSunsetAngle,
  setShowSunsetAngle,
}) {
  const iconColor = useColorModeValue("#4b635e", "#E9A6A6");
  const icon = <SunsetIcon color={iconColor} width="80%" />; // Always use the SunIcon for SunsetAngleButton

  return (
    <IconButton
      aria-label="Show Sunset Angle"
      icon={icon}
      onClick={() => setShowSunsetAngle(!showSunsetAngle)}
      size="md"
      boxShadow="lg"
    />
  );
}
